export default __webpack_public_path__ + "static/media/checkbox_on.e2dc18bd.svg";